import { CreateSecurityTypeRequest } from '../../../../web-api-client';
import { SecurityType } from '../../models';

export const mapSecurityTypeToCreateRequest = (
  securityType: SecurityType
): CreateSecurityTypeRequest => {
  return new CreateSecurityTypeRequest({
    name: securityType.name,
    isActive: securityType.isActive,
    parentSecurityTypeId: securityType.parentSecurityTypeId,
  });
};
